import React from 'react';
import {Route, Routes} from 'react-router-dom';
import {HomePage} from '../HomePage';
import HelpPage from '../HelpPage';
import AboutPage from '../AboutPage';
import PrivacyPolicy from '../PrivacyPolicy';
import PublicLayout from '../layouts/PublicLayout';
import BlogListScreen from '../screens/blog/BlogListScreen';
import BlogPostScreen from '../screens/blog/BlogPostScreen';
import {FeaturePage, NotFound} from './FeaturePage';
import {featurePages} from './featurePages';
export default function PublicSite() {
  return <div className="landing-host"><Routes>
    <Route path="/" element={<HomePage/>}/>
    <Route element={<PublicLayout/>}>
      <Route path="/about" element={<AboutPage/>}/>
      <Route path="/help" element={<HelpPage/>}/>
      <Route path="/policy" element={<PrivacyPolicy/>}/>
      <Route path="/blogs" element={<BlogListScreen/>}/>
      <Route path="/blogs/:slug" element={<BlogPostScreen/>}/>
      {featurePages.map(page => <Route key={page.path} path={page.path} element={<FeaturePage/>}/>)}
      <Route path="*" element={<NotFound/>}/>
    </Route>
  </Routes></div>;
}
